require('bootstrap/js/src/util');
require('bootstrap/js/src/toast');

export const success = (message) => notification('success', message);

export const danger = (message) => notification('danger', message);

export const warning = (message) => notification('warning', message);

export const notification = (type, message) => {
  const notificationTemplateWrapper = `
                <div class="toast position-fixed" role="alert" aria-live="assertive" aria-atomic="true">
                  <div class="container"></div>
                </div>
              `;
  const notificationTemplate = `
                <div class="toast-wrapper toast-wrapper-${type} position-relative">
                  <div class="toast-content" >
                    <div class="toast-body notification-message">${message}</div>
                    <button type="button" class="toast-close position-absolute" aria-label="Close"></button>
                  </div>
                </div>
              `;

  const notificationWrapperObject = $(notificationTemplateWrapper);
  const notificationObject = $(notificationTemplate);

  let toast = $('.toast');

  if ( toast.length === 0 ) {
    $('body').append( notificationWrapperObject );
    toast = notificationWrapperObject;
  }

  toast.find('.container').prepend( notificationObject );

  let delay = type === 'success' ? 5 : 10;

  let options = {
    // delay,
    autohide: false,
    animation: true
  };

  if (type !== 'success') {
    options.autohide = false;
  }

  notificationWrapperObject.toast(options);
  notificationWrapperObject.toast('show');

  // Toast animate events
  const hideToastMessage = () => {
    notificationObject.removeClass('toast-wrapper-show')
                      .on('transitionend', function(){
                        notificationObject.remove();
                      });
  };
  let hideToastMessageTimer = null;

  setTimeout(function(){
    notificationObject.addClass('toast-wrapper-show');
    hideToastMessageTimer = setTimeout(hideToastMessage, delay * 1000);
  }, 100);

  notificationObject.find('.toast-close').click(function(){
    hideToastMessage();
    clearTimeout( hideToastMessageTimer );
  });

};

$(function(){
  if ($jBoard.sessionStatus && $("#session-status").length === 0) {
    success($jBoard.sessionStatus);
  }

  if ($jBoard.dangerSessionStatus && $("#session-status").length === 0) {
    danger($jBoard.dangerSessionStatus);
  }
});
